"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseStyles = void 0;
var baseStyles_1 = __importDefault(require("./baseStyles"));
exports.baseStyles = baseStyles_1.default;
